import React, {useMemo, useState} from "react";
import styles from './ViewParticipationModal.module.scss';
import Button, {BUTTON_TYPE_SECONDARY} from "../../Components/Button/Button";
import moment from "moment";
import {walletFormatting} from "../../helpers/helperFunctions";

const explorer_link = "https://explorer.solana.com/tx/"

export const SALE_TYPE_RAFFLE = 'SALE_TYPE_RAFFLE'
export const SALE_TYPE_IDO = 'SALE_TYPE_IDO'

function ViewParticipationModal(props) {
    const {
        participationData,
        setParticipationData,
        saleType = SALE_TYPE_IDO,
        saleName,
    } = props;

    const {
        username,
        wallet,
        transactionAmount,
        transactions,
        lastTransactionTime,
        contributedStarsAmount,
        contributedUSDCAmount,
        purchasedTickets,
    } = participationData;

  const closeModal = () => {
    setParticipationData(null);
  }

  const transactionData = useMemo(() => {
      let totalStars = 0;
      let totalUSDC = 0;
      let totalTickets = 0;
      const mappedTransactions = transactions
          .sort((a, b) => a.timestamp - b.timestamp)
          .reverse()
          .map(transaction => {
          return (
              <div className={styles.transactionRow} key={transaction.id}>
                  {saleType === SALE_TYPE_RAFFLE && <div className={styles.txIdCell} onClick={() => window.open(explorer_link + transaction.txId, '_blank')}>
                      <span>{walletFormatting(transaction.txId)}</span>
                  </div>}
                  {saleType === SALE_TYPE_RAFFLE && <div className={styles.transactionCell}>
                      <span>{transaction.ticketAmount}</span>
                  </div>}
                  {saleType === SALE_TYPE_IDO && <div className={styles.transactionCell}>
                      <span>{transaction.starsAmount}</span>
                  </div>}
                  {saleType === SALE_TYPE_IDO && <div className={styles.transactionCell}>
                      <span>{transaction.usdcAmount}</span>
                  </div>}
                  <div className={styles.transactionCell}>
                      <span>{moment.unix(transaction.timestamp / 1000).format('YYYY-MM-DD, hh:mm:ss')}</span>
                  </div>
              </div>
          )
      })

      return {
          totalStars,
          totalUSDC,
          totalTickets,
          mappedTransactions,
      }
  }, [transactions]);

  return (
      <div className={styles.editCadetOverlay}>
          <div className={styles.editCadetContainer}>
              <h5>SOL WALLET: {wallet}</h5>
              <h5>Sale Name: {saleName}</h5>
              <span className={styles.text}>Total Transactions: {transactions.length}</span>
              {saleType === SALE_TYPE_IDO &&
                  <span className={styles.text}>Total Contributed Stars Amount: {contributedStarsAmount}</span>}
              {saleType === SALE_TYPE_IDO &&
                  <span className={styles.text}>Total Contributed USDC Amount: {contributedUSDCAmount}</span>}
              {saleType === SALE_TYPE_RAFFLE &&
                  <span className={styles.text}>Total Purchased Tickets: {purchasedTickets}</span>}
              <div className={styles.transactionContainer}>
                  <div className={styles.transactionRow} key={'header'}>
                      <div className={styles.transactionHeaderCell}>
                          <span>{saleType === SALE_TYPE_RAFFLE ? 'TX ID' : 'STARS Amount'}</span>
                      </div>
                      <div className={styles.transactionHeaderCell}>
                          <span>{saleType === SALE_TYPE_RAFFLE ? 'Tickets Purchased' : 'USDC Amount'}</span>
                      </div>
                      <div className={styles.transactionHeaderCell}>
                          <span>Transaction Time</span>
                      </div>
                  </div>
                  {transactionData.mappedTransactions}

              </div>
              <div className={styles.editCadetFooter}>
                  <Button text="CANCEL" onClick={closeModal} buttonType={BUTTON_TYPE_SECONDARY}/>
              </div>
          </div>
      </div>);
}

export default ViewParticipationModal;
